/* eslint-disable react/no-children-prop */
import { faCalendar, faClock } from '@fortawesome/pro-regular-svg-icons';
import { Button } from '@nazka/nazka.mapframe.components';

function DateButton(props) {
  return (
    <Button
      {...props} 
      children={null}
      className="date-time-select__date__button"
      icon={faCalendar}
      layout="ghost"
      hover={false}
    />
  );
}

function TimeButton(props) {
  return (
    <Button 
      {...props}
      children={null}
      className="date-time-select__time__button"
      icon={faClock}
      layout="ghost"
      hover={false}
    />
  );
}

export { DateButton, TimeButton };